import { FC, HTMLAttributes, useEffect } from "react";
import clsx from "classnames";
import { useStyles } from "./EssentialPack.style";
import { useGamepadContext } from "../../contexts/GamepadProvider";
import { onGameListMoveAction } from "../../models/gamepad";
import { HeroBanner } from "../../components/common/HeroBanner";
import { useQuery } from "@apollo/client";
import { Query } from "@onmo/graphql/graphql";
import { pageAaaGQL } from "../../graphql";
import { GameCategory } from "../../components/common/GameCategory";
import { MyLibraryCategory } from "../../components/common/MyLibraryCategory/MyLibraryCategory";
import map from "lodash-es/map";
import { isTV } from "../../utils/platform";
import { getMediaSizeScale } from "../../models/screen";
import { selectIsAuthenticated } from "@onmo/auth";
import { useAppSelector } from "../../components/hooks";
import { useProfileSwitchFade } from "../../hooks/useProfileSwitchFade";

const EssentialPack: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const classes = useStyles();
  const { setCallback, cleanup } = useGamepadContext();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const switchFade = useProfileSwitchFade();
  const { data: pageData } = useQuery<Query>(pageAaaGQL, {
    variables: { input: { page: "essential" } },
  });

  const defaultCardWidth = isTV ? 320 * getMediaSizeScale() : undefined;

  useEffect(() => {
    setCallback({
      onMoveAction: onGameListMoveAction,
    });

    return () => {
      cleanup();
    };
  }, [cleanup, setCallback]);

  return (
    <div className={classes.root}>
      <div
        className={clsx(classes.rootContent, switchFade)}
        id="essential-pack"
      >
        <HeroBanner type="essentialPack" />
        <div className={classes.content}>
          {isAuthenticated && (
            <MyLibraryCategory
              gameCategory="PID"
              group="my-library-pid"
              defaultCardWidth={defaultCardWidth}
            />
          )}
          {map(pageData?.page?.items, (section) => (
            <GameCategory
              key={section?.id}
              section={section}
              defaultCardWidth={defaultCardWidth}
              isCompactTag
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default EssentialPack;
